module.exports = __webpack_public_path__ + "img/alunos aprovados.f76ca99a.jpg";